<template>
  <div class="home">
  
    <Reproductor msg="La familia" audio2="../mp3/PrimariaA/03PA.mp3" cover="../img/1.jpg" name="Primaria A - Lección #3"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA3',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
